{
  "clear": "Limpar",
  "invalid": "(inválido)",
  "loading": "Carregando...",
  "noResults": "Nenhum resultado"
}
